/** =========================================================
 * Project part act remark template types controller
 =========================================================*/

(function () {
  'use strict';

  angular
    .module('app.page-project-part-act-remark-template-types')
    .controller('ProjectPartActRemarkTemplateTypesController', ProjectPartActRemarkTemplateTypesController);

  ProjectPartActRemarkTemplateTypesController.$inject = ['$rootScope', '$scope', '$state', '$stateParams', '$translate'];

  function ProjectPartActRemarkTemplateTypesController($rootScope, $scope, $state, $stateParams, $translate) {
    var vm = this;

    vm.pageTitle = $state.current.title;
    vm.pageSubTitle = $state.current.subTitle;
    vm.init = false;

    if ($rootScope.appConfig) {
      activate();
    } else {
      var getAppConfig = $rootScope.$watch('appConfig', function (value) {
        if (value) {
          activate();
          getAppConfig();
        }
      });
    }

    // //////////////

    function activate() {
      vm.init = true;

      Raven.captureBreadcrumb({
        message: 'Page project part remark types',
        data: {
          filters: $stateParams.filters
        }
      });

      vm.tableConfig = {
        model: 'project_part_act_remark_template_type',
        getDataParams: {
          order: {
            id: 'desc'
          },
          count: ['project_part_act_remark_templates']
        },
        filters: angular.copy($stateParams.filters),
        fields: [{
          title: 'Title',
          key: 'name',
          order: true
        }, {
          title: 'Color',
          key: 'color',
          customType: 'color'
        }],
        add: {
          template: 'app/views/dialogs/item-project-part-act-remark-template-type.html'
        },
        edit: {
          template: 'app/views/dialogs/item-project-part-act-remark-template-type.html',
          except: ['project_part_act_remark_templates_count']
        },
        delete: {},
        linkButtons: [{
          title: 'Project part act remark templates',
          icon: 'icon-dislike',
          class: 'btn-info',
          permission: $rootScope.helpers.hasPermissionTo('project_part_act_remark_template menu') && $rootScope.helpers.hasPermissionTo('project_part_act_remark_template view'),
          action: function (item) {
            try {
              $state.go('app.page-project-part-act-remark-templates', {
                filters: [{
                  name: $translate.instant('Project part act remark template type') + ': ' + item.name,
                  attr: 'where',
                  value: [
                    ['project_part_act_remark_template_type_id', '=', item.id]
                  ]
                }]
              });
            } catch (error) {
              Raven.captureException(error);
            }
          },
          text: function (item) {
            try {
              return item.project_part_act_remark_templates_count;
            } catch (error) {
              Raven.captureException(error);
            }

            return '';
          }
        }]
      };

      vm.tableConfig.getData = function () {
        try {
          return $rootScope.helpers.defaultGetData(vm.tableConfig);
        } catch (error) {
          Raven.captureException(error);
        }

        return $rootScope.helpers.emptyPromise();
      };

      vm.tableConfig.getData();

      $rootScope.helpers.initActiveTableConfig(vm.tableConfig);
    }
  }
})();
